import clsx from 'clsx';
import { ReactNode, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

interface ModalProps {
  onClose: () => void;
  children: ReactNode;
  className?: string;
  labelledBy?: string;
  zIndex?: number;
}

// Shared modal shell — extracted from the hand-rolled pattern repeated across
// TaskModal/TransferModal/BoardSettingsModal/the Slidebar delete-account confirm.
// Owns the overlay, click-outside, and Escape handling; callers supply the panel content.
export function Modal({ onClose, children, className, labelledBy, zIndex = 100 }: ModalProps) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/60 p-4 backdrop-blur-[2px]"
      style={{ zIndex }}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={twMerge(clsx('w-full max-w-md rounded-xl bg-base-100 shadow-panel', className))}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
      >
        {children}
      </div>
    </div>
  );
}
